import { Timeout } from '../common/const';
import { testRegexInput } from '../common/utils';

/**
 * @range
 * @constructor
 */
class Range {
    /**
     * @param {Object} el Range block
     * @param {Object} block Two range toddler
     * @param {Object} props Properties of range
     */
    constructor(block) {
        this.block = block;
        this.inputMin = this.block.querySelector(`[data-min]`);
        this.inputMax = this.block.querySelector(`[data-max]`);
        this.inputs = [this.inputMin, this.inputMax];
        this.line = this.block.querySelector(`[data-range-line]`);
        this.defaultValues = [this.inputMin.value, this.inputMax.value];
    }

    // Create range
    createRange() {
        noUiSlider.create(this.line, {
            start: [this.inputMin.value, this.inputMax.value],
            connect: true,
            range: {
                'min': parseInt(this.inputMin.getAttribute(`data-min`)),
                'max': parseInt(this.inputMax.getAttribute(`data-max`))
            },
            step: 1,
            format: wNumb({
                decimals: 0,
            }),
        });
    }

    changeInputsValue() {
        this.inputMin.addEventListener(`mouseleave`, (e) => {
            const target = e.target;
            const value = target.value;

            if (this.defaultValues[0] !== value) {
                this.line.noUiSlider.set([target.value, null]);
                this.defaultValues[0] = value;
            }
        });

        this.inputMax.addEventListener(`mouseleave`, (e) => {
            const target = e.target;
            const value = target.value;

            if (this.defaultValues[1] !== value) {
                this.line.noUiSlider.set([null, target.value]);
                this.defaultValues[1] = value;
            }
        });

        this.inputs.forEach(input => {
            input.addEventListener(`keypress`, (e) => {
                const regex = /[0-9]|\./;
                testRegexInput(e, regex);
            });
        });
    }

    // Update range on change range values
    updateRange() {
        let timer = 0;
        const _this = this;

        this.line.noUiSlider.on(`update`, function (values, handle) {
            _this.inputs[handle].value = values[handle];
            const value = _this.inputs[handle].value;

            clearTimeout(timer);
            timer = setTimeout(() => {
                if (_this.defaultValues[handle] !== value) {
                    // $(_this.inputs[handle]).trigger(`change`);
                    _this.defaultValues[handle] = value;
                }
            }, Timeout.ANIMATION_TOGGLE);
        });
    }

    init() {
        this.createRange();
        this.changeInputsValue();
        this.updateRange();
    }
}

export const initRange = () => {
    const rangeBlocks = document.querySelectorAll(`[data-range]`);
    if (!rangeBlocks.length) return;

    window.ranges = [];
    rangeBlocks.forEach((range, index) => {
        let _range = new Range(range);
        window.ranges[index] = _range;
        _range.init();
    });
}

window.initRange = (block) => new Range(block).init();
